import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { AvatarGroup } from "@design-system/Avatar/AvatarGroup";
import {
    InstitutionIcon,
    type InstitutionKey,
} from "@design-system/InstitutionIcon/InstitutionIcon";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";

interface IntegrationLogo {
    name: string;
    institution: InstitutionKey;
}

const FREE_PLAN_LOGOS: IntegrationLogo[] = [
    { name: "Stripe", institution: "stripe" },
    { name: "PayPal", institution: "paypal" },
    { name: "Mercury", institution: "mercury" },
    { name: "Ramp", institution: "ramp" },
    { name: "Plaid", institution: "plaid" },
];

const BASIC_PLAN_LOGOS: IntegrationLogo[] = [
    { name: "Gusto", institution: "gusto" },
    { name: "ChatGPT", institution: "chatgpt" },
    { name: "Claude", institution: "claude" },
    { name: "Cursor", institution: "cursor" },
];

const FREE_PLAN_EXTRA_INTEGRATIONS_COUNT = 50;

const IntegrationLogoGroup = ({
    logos,
    extraCount,
}: {
    logos: IntegrationLogo[];
    extraCount?: number;
}) => (
    <AvatarGroup
        items={logos}
        getKey={({ name }) => name}
        getLabel={({ name }) => name}
        renderAvatar={({ name, institution }) => (
            <AvatarTooltip content={name}>
                <InstitutionIcon institution={institution} label={name} />
            </AvatarTooltip>
        )}
        max={5}
        extraCount={extraCount}
        size="sm"
    />
);

export const KeyFeatureAppendixIcons = ({
    plan,
}: {
    plan: FLAT_RATE_PLANS;
}) => {
    if (plan === FLAT_RATE_PLANS.FREE) {
        return (
            <IntegrationLogoGroup
                logos={FREE_PLAN_LOGOS}
                extraCount={FREE_PLAN_EXTRA_INTEGRATIONS_COUNT}
            />
        );
    }

    if (plan === FLAT_RATE_PLANS.BASIC) {
        return <IntegrationLogoGroup logos={BASIC_PLAN_LOGOS} />;
    }

    return null;
};
